// extracted by mini-css-extract-plugin
export var content = "ContactDescription-module--content--Nqj8Q";